import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";


export const selectAllReports = ({ HsqeReport_reducer }) => {
    return HsqeReport_reducer.reports;
};

export const selectHsqeTemplates = ({HsqeReport_reducer}) => {
    return HsqeReport_reducer.template
}

export const selectUsers = ({HsqeReport_reducer}) => {
    return HsqeReport_reducer.users
}

export const selectSpecificTemplates = ({HsqeReport_reducer}) => {
    return HsqeReport_reducer.specificTemplate
}

export const selectMonth = ({ HsqeReport_reducer }) => {
    return HsqeReport_reducer.month;
};

export const selectYear = ({ HsqeReport_reducer }) => {
    return HsqeReport_reducer.year;
};

export const getRequesting = ({ HsqeReport_reducer }) => {
    return HsqeReport_reducer.requesting;
};

export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["help"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);

export const templateList = createSelector(
[selectHsqeTemplates],(templates) => {
    let finalResult = []
    Object.values(templates).map((e)=>{
        if(e.profile.deleted === false){
            finalResult.push(e)
            return null
        }
        return null;
    })
    return finalResult;
}
);

export const selectReportsForExcel = createSelector(
    [
        selectAllReports,
        selectMonth,
        selectYear,
        // selectJobPackReports
    ],
    (
        allReports = false,
        month = moment().format("MMM").toLowerCase(),
        year = moment().format("YYYY"),
        // allJobPackReports = false,
        reportType = "custom_report"
    ) => {
        if (
            reportType &&
            reportType !== "all_categories" &&
            allReports &&
            reportType !== "vehicle_alerts"
        ) {
            let reports;

            if (allReports)
                reports = getReportsTemp(allReports, reportType, month, year);
            // if (allJobPackReports)
            //     jobPackReports = getJPReports(
            //         allJobPackReports,
            //         reportType,
            //         month,
            //         year
            //     );
            //     console.table(jobPackReports,"jobPackReports")
            if (
                Object.keys(reports).length === 0
                // Object.keys(jobPackReports).length === 0
            )
                return false;

            if (reports) {
                // if (reportType === "custom_report") {
                //     var finalArray = {};
                //     Object.values(reports).map((report) => {
                //         if (report.config === filterTemplate) {
                //             finalArray = _.assign(finalArray, {
                //                 [report.timestamp]: report,
                //             });
                //             return null;
                //         } else {
                //             return null;
                //         }
                //     });
                //     return [finalArray];
                // } else {

                return [reports];
                // }
            } else if (reports) {
                return [reports];
            } else if (!reports) {
                return;
            } else return false;
        } else return false;
    }
);

export const selectReportCounterData = createSelector(
    [selectAllReports, selectMonth, selectYear, selectSpecificTemplates],
    (
        allReports = false,
        month = moment().format("MMM").toLowerCase(),
        year = moment().format("YYYY"),
        filterTemplate = false,
        reportType = "custom_report"
    ) => {
        if (
            reportType &&
            reportType !== "all_categories" &&
            allReports &&
            reportType !== "vehicle_alerts"
        ) {
            let reports;

            if (allReports)
                reports = getReports(allReports, reportType, month, year);
            if (Object.keys(reports).length === 0) return false;

            if (reports) {
                if (reportType === "custom_report") {
                    var finalArray = {};
                            Object.values(reports).map((report) => {
                                if (report.config === filterTemplate) {
                                    finalArray = _.assign(finalArray, {
                                        [report.timestamp]: report,
                                    });
                                    return null;
                                } else {
                                    return null;
                                }
                            });
                            return [finalArray];
                } else {
                    return [reports];
                }
            } else if (reports) {
                return [reports];
            } else if (!reports) {
                return;
            } else return false;
        } else return false;
    }
);


export const selectReportOverallData = createSelector(
    [selectAllReports, selectMonth, selectYear],
    (
        allReports = false,
        month = moment().format("MMM").toLowerCase(),
        year = moment().format("YYYY"),
        // filterTemplate = false,
        reportType = "custom_report"
    ) => {
        if (
            reportType &&
            reportType !== "all_categories" &&
            allReports &&
            reportType !== "vehicle_alerts"
        ) {
            let reports;

            if (allReports)
                reports = getReports(allReports, reportType, month, year);
            if (Object.keys(reports).length === 0) return false;

            if (reports) {
                if (reportType === "custom_report") {
                    var finalArray = {};
                            Object.values(reports).map((report) => {
                                    finalArray = _.assign(finalArray, {
                                        [report.timestamp]: report,
                                    });
                                    return null;
                            });
                            return [finalArray];
                } else {
                    return [reports];
                }
            } else if (reports) {
                return [reports];
            } else if (!reports) {
                return;
            } else return false;
        } else return false;
    }
);

export const selectAssignedUsers = createSelector (
[selectUsers], (users = false) => {
    if(users) {
        let finalUsers = []
        
        Object.values(users).map((e)=>{
            let obj = {}
            if(typeof e.assigned_items !== "undefined" ){
                obj['uid'] = e.profile.uid
                obj['profile_url'] = e.profile.profile_image_url
                obj['fname'] = e.profile.first_name
                obj['lname'] = e.profile.last_name
                obj['assigned_items'] = e.assigned_items
                finalUsers.push(obj)
            }
            return null;
        })
        return finalUsers
    }
}
);

// const getJPReports = (allJPReports, reportType, month, year) => {
//     let reps = {};
//     _.compact(
//         Object.keys(allJPReports).map((e) => {
//             let jps = _.get(allJPReports[e], `${year}.${month}`) || null;
//             if (jps)
//                 _.compact(
//                     Object.keys(jps).map((id) => {
//                         let reports =
//                             _.get(jps[id], `reports.${reportType}`) || null;
//                         if (reports) reps = _.assign(reps, { ...reports });
//                         return null;
//                     })
//                 );
//             return null;
//         })
//     );
//     return reps !== {} ? reps : null;
// };



const getReports = (allReports, reportType, month, year) => {
    allReports = _.compact(
        Object.keys(allReports).map((e) => {
            return _.get(allReports[e], `reports.${reportType}`) || null;
        })
    );
    return filterByDate(allReports, month, year);
};

const getReportsTemp = (allReports, reportType, month, year) => {
    allReports = _.compact(
        Object.keys(allReports).map((e) => {
            return _.get(allReports[e], `reports.${reportType}`) || null;
        })
    );
    return [allReports];
};

const filterByDate = (reports, month, year) => {
    let object = {};
    reports &&
        reports.map((e) => {
            Object.keys(e).map((f) => {
                let date = f.split(" ")[0];
                let curMonth = moment(date, "DD-MM-YYYY")
                    .format("MMM")
                    .toLowerCase();
                let curYear = moment(date, "DD-MM-YYYY").format("YYYY");
                if (month === curMonth && Number(year) === Number(curYear))
                    object = _.assign(object, { [f]: e[f] });
                return null;
            });
            return null;
        });

    return object;
};